export const EMAIL_EXISTED = 700;
export const WRONG_PASSWORD = 701;
export const EMAIL_NOT_EXISTED = 702;
export const EMAIL_INVALID = 703;
export const USERNAME_INVALID = 704;
export const NEED_BE_REGISTERED = 710;
export const NEED_BE_ACTIVATED = 711;
export const WRONG_RESET_PASSWORD_HASH = 715;
export const COMMENT_TIME_UPDATE_ENDS = 720;
export const INCORRECT_COMMENT_USER = 721;
